/* knowledge-cards-row.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./knowledge-cards-row.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { AgentStyles, PersonStyles, WorkStyles } from './styled';
import { KnowledgeCardsRowType } from './types';
var styles = {
  root: "_2rko12b0 _12l2u2gc _irr319i6 _d0altlke"
};
export var KnowledgeCardsRow = function KnowledgeCardsRow(_ref) {
  var primaryText = _ref.primaryText,
    secondaryText = _ref.secondaryText,
    pictureUrl = _ref.pictureUrl,
    type = _ref.type,
    triggerProps = _ref.triggerProps,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: styles.root,
    paddingInline: "space.200",
    paddingBlock: "space.100"
  }, triggerProps, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, type === KnowledgeCardsRowType.PERSON ? /*#__PURE__*/React.createElement(PersonStyles, {
    src: pictureUrl,
    alt: ""
  }) : /*#__PURE__*/React.createElement(WorkStyles, {
    src: pictureUrl,
    alt: ""
  }), /*#__PURE__*/React.createElement(Stack, {
    spread: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    maxLines: 1
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xxsmall"
  }, primaryText)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "color.text.subtlest",
    maxLines: 1
  }, secondaryText))));
};
export var KnowledgeCardsRowRefresh = function KnowledgeCardsRowRefresh(_ref2) {
  var primaryText = _ref2.primaryText,
    secondaryText = _ref2.secondaryText,
    pictureUrl = _ref2.pictureUrl,
    type = _ref2.type,
    triggerProps = _ref2.triggerProps,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: styles.root,
    paddingInline: "space.200",
    paddingBlock: "space.075"
  }, triggerProps, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, type === KnowledgeCardsRowType.WORK ? /*#__PURE__*/React.createElement(WorkStyles, {
    src: pictureUrl,
    alt: ""
  }) : type === KnowledgeCardsRowType.AGENT ? /*#__PURE__*/React.createElement(AgentStyles, {
    src: pictureUrl,
    alt: ""
  }) : /*#__PURE__*/React.createElement(PersonStyles, {
    src: pictureUrl,
    alt: ""
  }), /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Text, {
    maxLines: 1
  }, primaryText), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "color.text.subtlest",
    maxLines: 1
  }, secondaryText))));
};